import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';

import { UserService } from '@core/services/user.service';

import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { passwordValidator, validateFormGroup  } from '@shared/utils/form.util';


@UntilDestroy()
@Component({
  selector: 'app-register',
  templateUrl: './register.component.html'
})
export class RegisterComponent implements OnInit {

  registerForm: FormGroup;
  routeActive: boolean;
  showLogin = false;
  loading = false;
  root: boolean;

  registerPasswordVisible = false;

  constructor(
    private fb: FormBuilder,
    private userService: UserService,
    private route: ActivatedRoute,
    private router: Router
  ) {
    this.root = route.snapshot.data.root;
    router.events.pipe(untilDestroyed(this)).subscribe(evt => {
      if ((evt instanceof NavigationEnd)) {
        this.routeActive = evt.url === '/register';
        if (this.routeActive) {
          this.router.navigateByUrl('/');
        }
      }
    });
  }

  ngOnInit(): void {
    this.registerForm = this.fb.group({
      email: [this.root ? 'root' : null, [Validators.required]],
      password: [null, [Validators.required, passwordValidator]],
      confirm: ['' , [Validators.required, this.confirmValidator]],
    });
  }

  submitForm(): void {
    if (this.loading) {
      return;
    }

    validateFormGroup(this.registerForm);

    if (this.registerForm.invalid) {
      return;
    }

    const data = {
      username: this.registerForm.value.email,
      password: this.registerForm.value.password,

    };

    this.loading = true;
    this.userService.createRoot(data)
      .pipe(untilDestroyed(this))
      .subscribe(_ => {
      this.loading = false;
      this.showLogin = true;
    }, error => {
      this.loading = false;
      console.log('error while creating root user', error);
    });
  }

  confirmValidator = (control: FormControl): { [s: string]: boolean } => {
    if (!control.value) {
      return { error: true, required: true };
    } else if (control.value !== this.registerForm.controls.password.value) {
      return { confirm: true, error: true };
    }
    return {};
  };

  validateConfirmPassword(): void {
    setTimeout(() => this.registerForm.controls.confirm.updateValueAndValidity());
  }
}
